import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getConfig } from '../config';
import { VCObserver } from '../vc/vc-observer';
var POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var PostInteractionLog = /*#__PURE__*/function () {
  function PostInteractionLog() {
    _classCallCheck(this, PostInteractionLog);
    /**
     * Basic info about interaction that has just finished
     */
    _defineProperty(this, "lastInteractionFinish", null);
    /**
     * Array of observed react render timings
     */
    _defineProperty(this, "reactProfilerTimings", []);
    /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */
    _defineProperty(this, "sinkTimeoutId", null);
    /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */
    _defineProperty(this, "vcObserver", null);
    _defineProperty(this, "vcObserverSSRConfig", null);
    /**
     * Handler function to process / send the observation data
     */
    _defineProperty(this, "sinkHandlerFn", function () {});
  }
  _createClass(PostInteractionLog, [{
    key: "initializeVCObserver",
    value: function initializeVCObserver(options) {
      if (this.vcObserver === null) {
        this.vcObserver = new VCObserver(_objectSpread(_objectSpread({}, options), {}, {
          isPostInteraction: true
        }));
      }
    }
  }, {
    key: "startVCObserver",
    value: function startVCObserver(_ref) {
      var _this$vcObserver;
      var startTime = _ref.startTime;
      (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
        startTime: startTime
      });
    }
  }, {
    key: "setVCObserverSSRConfig",
    value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
      this.vcObserverSSRConfig = vcObserverSSRConfig;
    }

    /**
     * Set the VC result as per the last interaction
     * Used to compare diffs of VC updates vs post interaction VC observer
     * @param result - VC result as calculated by UFO create payload
     */
  }, {
    key: "setLastInteractionFinishVCResult",
    value: function setLastInteractionFinishVCResult(result) {
      this.lastInteractionFinishVCResult = result;
    }
  }, {
    key: "sinkHandler",
    value:
    /**
     * Set the fn that would be invoked to process / send the observation data
     */
    function sinkHandler(sinkHandlerFn) {
      this.sinkHandlerFn = sinkHandlerFn;
    }

    /**
     * Reset state of the log
     */
  }, {
    key: "reset",
    value: function reset() {
      this.lastInteractionFinish = null;
      this.reactProfilerTimings = [];
      if (this.sinkTimeoutId != null) {
        clearTimeout(this.sinkTimeoutId);
        this.sinkTimeoutId = null;
      }
      this.setVCObserverSSRConfig(null);
    }

    /**
     * Check if there is data in the log
     */
  }, {
    key: "hasData",
    value: function hasData() {
      var _this$reactProfilerTi;
      return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
    }

    /**
     * Send the log if there is data
     */
  }, {
    key: "sendPostInteractionLog",
    value: function sendPostInteractionLog() {
      var _this$vcObserver2;
      if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
        this.reset();
        return;
      }
      this.sinkHandlerFn({
        lastInteractionFinish: this.lastInteractionFinish,
        reactProfilerTimings: this.reactProfilerTimings,
        // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
        postInteractionFinishVCResult: (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 ? void 0 : _this$vcObserver2.getVCResult(_objectSpread({
          start: this.lastInteractionFinish.start,
          stop: performance.now(),
          tti: -1,
          // no need for TTI value here
          prefix: 'ufo'
        }, this.vcObserverSSRConfig)),
        lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
      });
      this.reset();
    }

    /**
     * This fn should be invoked when an interaction has finished
     * Basic details about the finished interaction will be recorded
     * A timeout will be setup to send the post interaction observation after some time.
     */
  }, {
    key: "onInteractionComplete",
    value: function onInteractionComplete(_ref2) {
      var _getConfig,
        _this = this;
      var ufoName = _ref2.ufoName,
        start = _ref2.start,
        end = _ref2.end,
        id = _ref2.id,
        abortReason = _ref2.abortReason,
        abortedByInteractionName = _ref2.abortedByInteractionName,
        routeName = _ref2.routeName,
        type = _ref2.type;
      this.lastInteractionFinish = {
        ufoName: ufoName,
        start: start,
        end: end,
        id: id,
        abortReason: abortReason,
        abortedByInteractionName: abortedByInteractionName,
        routeName: routeName,
        type: type
      };
      var timeout = ((_getConfig = getConfig()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
      this.sinkTimeoutId = window.setTimeout(function () {
        _this.sendPostInteractionLog();
      }, timeout);
    }

    /**
     * This fn should be invoked when a React render happens after interaction has finished
     */
  }, {
    key: "addProfilerTimings",
    value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
      if (this.lastInteractionFinish != null) {
        this.reactProfilerTimings.push({
          type: type,
          actualDuration: actualDuration,
          baseDuration: baseDuration,
          startTime: startTime,
          commitTime: commitTime,
          labelStack: labelStack
        });
      }
    }
  }]);
  return PostInteractionLog;
}();
export { PostInteractionLog as default };